import React from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { connect } from 'react-redux' 
import useStyles from "./style";

import { isHamburguerMenu } from '../../utils/objectManipulations'

const mapState=(state)=>({
  user: state.auth.user.mainGroup,
  envSettings: state.auth.envSettings
})

const getCurrentYear = () => {
  return new Date().getFullYear();
};

const Footer = ({user, envSettings}) => {
  const classes = useStyles();
  const { appVersion } = envSettings

  return (
    <Paper classes={
      isHamburguerMenu(user) ? 
      { root: classes.footer } : 
      { root: classes.notHamburguer}
      }>
      <Grid container spacing={2}>
        <Grid item md={6} sm={8} xs={12}>
          <Grid container>
            <Grid item md={2} sm={4} xs={12}>
              <Button
                variant="text"
                data-cy="footer-privacy"
                id="footer-privacy"
                classes={{
                  root: classes.button,
                  label: classes.buttonLabel,
                }}
                onClick={() =>
                  window.open(
                    "https://www.cargill.com/page/privacy-pt",
                    "_blank"
                  )
                }
              >
                Privacidade
              </Button>
            </Grid>
            <Grid item md={3} sm={4} xs={12}>
              <Button
                variant="text"
                data-cy="footer-comercial-alert"
                id="footer-comercial-alert"
                classes={{
                  root: classes.button,
                  label: classes.buttonLabel,
                }}
                onClick={() =>
                  window.open(
                    "https://www.cargill.com/page/business-notice",
                    "_blank"
                  )
                }
              >
                Aviso Comercial
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={6}
          sm={4}
          xs={12}
          classes={{ root: classes.copyrightContainer }}
        >
          <Typography
            variant="caption"
            color="inherit"
            classes={{ root: classes.copyrightContent }}
          >
           v{appVersion} © {getCurrentYear()} Cargill, Incorporated. Todos os direitos reservados.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default connect(mapState)(Footer);
